import { ThemePicker } from "../../lib/ThemePicker.tsx";
import { Dialog } from "./Dialog.tsx";

/**
 * Светлая или тёмная.
 *
 * Окном, а не разделом настроек, по той же причине, что подпись на доске и
 * смена пароля: экрана профиля в продукте нет. Когда он появится, окно
 * переедет туда без изменений, оно не знает ни про сайдбар, ни про адрес.
 *
 * ⚠️ Кнопки «Сохранить» здесь нет намеренно. Ручки у настройки тоже нет: выбор
 * живёт в браузере (решение владельца 02.09.2026), применяется мгновенно, и
 * человек видит результат на самом окне, пока оно открыто. «Сохранить» здесь
 * означало бы просить подтвердить то, что уже произошло.
 */
export function ThemeDialog(props: { onClose: () => void }) {
  return (
    <Dialog title="Светлая или тёмная" onClose={props.onClose}>
      {/*
        Подвала нет: закрывать это единственное, что тут можно сделать, а
        «Закрыть» стоит в шапке окна. Вторая такая же кнопка внизу была бы не
        запасным выходом, а вопросом «какая из них настоящая».
      */}
      <div className="form">
        <ThemePicker />
        <p className="hint">
          «Как в системе» это то, что стоит в настройках телефона или компьютера. Выбор
          запоминается в этом браузере: на другом телефоне или компьютере выберите заново.
        </p>
      </div>
    </Dialog>
  );
}
